/**
 * Constantes e helpers compartilhados das telas de Parceiros (lista + cockpit
 * + form). Centralizados aqui para evitar duplicacao (DRY) entre `index.jsx`,
 * `Detalhe.jsx` e `FormPanel.jsx`.
 */

// Os CINCO tipos de `TIPOS_REPRESENTANTE` (comercial/models.py), numa lista
// so (CRM-47). O seletor do form usava tres: a loja que indica clientes so
// podia ser cadastrada como Arquiteto — e entrava na conta de arquitetos —,
// e parceiro importado como REVENDEDOR abria sem nenhum tipo marcado.
// "Broker" e o nome que o comercial usa para CORRETOR.
export const TIPOS_PARCEIRO = [
  ["ARQUITETO", "Arquiteto"],
  ["DESIGNER", "Designer"],
  ["REVENDEDOR", "Revendedor"],
  ["CORRETOR", "Broker"],
  ["OUTRO", "Outro"],
];

// Opcoes do segmented do form e rotulos das listas saem da MESMA lista.
export const SEG_TIPOS = TIPOS_PARCEIRO;

export const TIPO_LABEL = Object.fromEntries(TIPOS_PARCEIRO);

export const CICLOS = [
  ["", "—"],
  ["MENSAL", "Mensal"],
  ["QUINZENAL", "Quinzenal"],
  ["POR_PEDIDO", "Por pedido fechado"],
  ["POR_ENTREGA", "Por entrega"],
  ["OUTRO", "Outro"],
];

export const CICLO_LABEL = Object.fromEntries(CICLOS);

// Redes sociais do parceiro. `base` monta o link a partir do @usuario;
// URL completa e' respeitada como veio (ver urlRedeSocial).
export const REDES_SOCIAIS = [
  { key: "instagram", label: "Instagram", base: "https://www.instagram.com/", placeholder: "@usuario ou link" },
  { key: "pinterest", label: "Pinterest", base: "https://br.pinterest.com/", placeholder: "@usuario ou link" },
  { key: "linkedin", label: "LinkedIn", base: "https://www.linkedin.com/in/", placeholder: "usuario ou link" },
  { key: "youtube", label: "YouTube", base: "https://www.youtube.com/@", placeholder: "@canal ou link" },
];

const CAMPOS_REDES_VAZIOS = Object.fromEntries(REDES_SOCIAIS.map((r) => [r.key, ""]));

/** Link clicavel para o perfil: aceita "@usuario", "usuario", "site.com/x" ou URL. */
export function urlRedeSocial(key, valor) {
  const v = String(valor || "").trim();
  if (!v) return "";
  if (/^https?:\/\//i.test(v)) return v;
  const rede = REDES_SOCIAIS.find((r) => r.key === key);
  if (!rede) return "";
  const semArroba = v.replace(/^@/, "").replace(/^\/+/, "");
  // "instagram.com/fulano" sem protocolo: so falta o https.
  // Exige a barra: "arq.ana" e' um @usuario com ponto, nao um dominio.
  if (/^(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)+\//i.test(semArroba)) return `https://${semArroba}`;
  return rede.base + semArroba;
}

export const VAZIO = {
  nome: "",
  documento: "",
  email: "",
  telefone: "",
  tipo: "ARQUITETO",
  comissao_percentual: "5.00",
  responsavel: "",
  cidade: "",
  uf: "",
  ...CAMPOS_REDES_VAZIOS,
  banco: "",
  chave_pix: "",
  ciclo_pagamento: "MENSAL",
  observacoes: "",
  ativo: true,
};

// Rotulo de secao (mockup) — pequena maiuscula espacada. Inline porque a
// classe canonica `.input-section-label` nao existe no design system.
export const SECAO_STYLE = {
  fontSize: 10.5,
  fontWeight: 700,
  letterSpacing: "0.05em",
  textTransform: "uppercase",
  color: "var(--ink-3)",
};

export function iniciais(nome) {
  const partes = String(nome || "").trim().split(/\s+/).filter(Boolean);
  if (!partes.length) return "—";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
}

export function fmtBRLCompacto(valor) {
  const n = Number(valor || 0);
  if (!Number.isFinite(n) || n === 0) return "R$ 0";
  if (n >= 1_000_000) return `R$ ${(n / 1_000_000).toFixed(1).replace(".0", "")}M`;
  if (n >= 1_000) return `R$ ${Math.round(n / 1_000)}k`;
  return `R$ ${n.toLocaleString("pt-BR", { maximumFractionDigits: 0 })}`;
}
